import columnSizes from './column-sizes.variables';
import { minWidth as minWidthGenerator } from 'helpers/buildMediaQueries';

const gridTemplateMediaQueries = columnSizes
  .map(({ minWidth, containerWidth }) =>
    minWidthGenerator(
      minWidth,
      `grid-template-columns: 1fr ${containerWidth}px 1fr;`
    )
  )
  .join('');

const gridTemplates = `
  grid-template-columns: 0;
  ${gridTemplateMediaQueries}
`;

export const navigationHeightsValues: { minWidth: string; height: number }[] = [
  {
    minWidth: 'xs',
    height: 72
  },
  {
    minWidth: 'md',
    height: 82
  }
];

const navigationWidthsMediaQueries = columnSizes
  .map(({ minWidth, containerWidth }) =>
    minWidthGenerator(minWidth, `max-width: ${containerWidth}px;`)
  )
  .join('');

const navigationSeparatorWidthsMediaQueries = columnSizes
  .map(({ minWidth, containerWidth }) =>
    minWidthGenerator(minWidth, `width: ${containerWidth - 32}px;`)
  )
  .join('');

export const headerVariables = {
  navigationWidths: navigationWidthsMediaQueries,
  navigationSeparatorWidths: navigationSeparatorWidthsMediaQueries,
  gridTemplates: gridTemplates,
  navigationPadding: '16px',
  innerNavigationHeight: '36px'
};
